import React from 'react';
import { ExtraMenuWords } from '@fundera/fundera-design-system';

const pillarPageLinks = [
  {
    name: 'Loans',
    path: '/business-loans',
    link: [
      {
        category: 'Loan Types',
        links: [
          { label: 'SBA Loans', path: '/business-loans/sba-loans' },
          {
            label: 'Business Lines of Credit',
            path: '/business-loans/business-line-of-credit',
          },
          { label: 'Term Loans', path: '/business-loans/business-term-loans' },
          {
            label: 'Startup Business Loans',
            path: '/business-loans/startup-business-loans',
          },
          {
            label: 'Equipment Financing',
            path: '/business-loans/equipment-financing',
          },
          {
            label: 'Invoice Financing',
            path: '/business-loans/invoice-financing',
          },
        ],
      },
      {
        category: 'Learn',
        links: [
          {
            label: 'Best Small Business Loans for Women',
            path: '/business-loans/guides/small-business-loans-for-women',
          },
          {
            label: 'Business Loans for Bad Credit',
            path: '/business-loans/guides/business-loans-for-bad-credit',
          },
          {
            label: 'Consolidating Debt With a Business Loan',
            path: '/business-loans/guides/business-debt-consolidation-loan',
          },
          {
            label: 'Best Banks for Business Loans',
            path: '/business-loans/guides/best-banks-for-business-loans',
          },
          {
            label: 'How to Get a Business Loan',
            path: '/business-loans/guides/how-to-get-a-business-loan',
          },
          {
            label: 'Business Loan Requirements',
            path: '/business-loans/guides/business-loan-requirements',
          },
        ],
      },
    ],
  },
  {
    name: 'Banking',
    path: '/business-bank-accounts',
    link: [
      {
        category: 'Best Of',
        links: [
          {
            label: 'Best Online Bank Accounts',
            path: 'https://www.fundera.com/blog/best-places-open-business-checking-account-online',
          },
          {
            label: 'Best Business Checking Accounts',
            path: '/business-bank-accounts/checking',
          },
          {
            label: 'Best Free Business Checking Accounts',
            path: 'https://www.fundera.com/blog/free-business-checking',
          },
          {
            label: 'Best Business Savings Accounts',
            path: 'https://www.fundera.com/business-bank-accounts/savings',
          },
          {
            label: 'Best Bank Accounts for LLCs',
            path: 'https://www.fundera.com/blog/best-business-checking-account-for-llc',
          },
        ],
      },
      {
        category: 'Learn',
        links: [
          {
            label: 'How to Open a Business Bank Account',
            path: 'https://www.fundera.com/blog/what-do-i-need-to-open-a-business-bank-account',
          },
          {
            label: 'Opening a Business Bank Account With No Deposit',
            path: 'https://www.fundera.com/blog/open-a-free-business-checking-account-online-with-no-deposit',
          },
          {
            label: 'Opening a Business Bank Account Without an EIN',
            path: 'https://www.fundera.com/blog/can-i-open-a-business-bank-account-without-an-ein',
          },
        ],
      },
    ],
  },
  {
    name: 'Accounting',
    path: '/business-accounting',
    link: [
      {
        category: 'Best Of',
        links: [
          {
            label: 'Best Accounting Software for Ecommerce',
            path: 'https://www.fundera.com/blog/best-accounting-software-for-ecommerce-businesses',
          },
          {
            label: 'Best Accounting Software for Restaurants',
            path: 'https://www.fundera.com/blog/restaurant-accounting-software',
          },
          {
            label: 'Best Accounting Software for Sole Proprietors',
            path: 'https://www.fundera.com/blog/self-employed-accounting-software',
          },
          {
            label: 'Best Free Accounting Software',
            path: '/business-accounting/free-accounting-software',
          },
          {
            label: 'Best Bookkeeping Apps',
            path: 'https://www.fundera.com/blog/bookkeeping-apps',
          },
        ],
      },
      {
        category: 'Accounting Comparisons',
        links: [
          {
            label: 'QuickBooks vs. FreshBooks',
            path: 'https://www.fundera.com/blog/freshbooks-vs-quickbooks',
          },
          {
            label: 'Xero vs. QuickBooks',
            path: '/business-accounting/xero-vs-quickbooks-online',
          },
          { label: 'Xero vs. Sage', path: '/business-accounting/xero-vs-sage' },
          {
            label: 'QuickBooks Online vs. Desktop',
            path: '/business-accounting/quickbooks-online-vs-desktop',
          },
          {
            label: 'QuickBooks Pro vs. Premier',
            path: '/business-accounting/quickbooks-pro-vs-premier',
          },
        ],
      },
      {
        category: 'Learn',
        links: [
          {
            label: 'Accounting Principles',
            path: 'https://www.fundera.com/blog/accounting-principles',
          },
          {
            label: 'How to Find an Accountant',
            path: 'https://www.fundera.com/blog/business-accountant',
          },
          {
            label: 'Accounting Tips',
            path: 'https://www.fundera.com/blog/small-business-accounting-tips',
          },
          {
            label: 'Bookkeeping vs. Accounting',
            path: 'https://www.fundera.com/blog/bookkeeping-vs-accounting',
          },
        ],
      },
    ],
  },
  {
    name: (
      <>
        POS
        <ExtraMenuWords>Systems</ExtraMenuWords>
      </>
    ),
    path: 'https://www.fundera.com/blog/pos-systems',
    link: [
      {
        category: 'Best Of',
        links: [
          {
            label: 'Best Credit Card Processing Companies',
            path: 'https://www.fundera.com/blog/credit-card-processing-companies',
          },
          {
            label: 'Best Merchant Account Providers',
            path: 'https://www.fundera.com/blog/merchant-account-providers',
          },
          {
            label: 'Best Mobile Credit Card Readers',
            path: 'https://www.fundera.com/blog/mobile-credit-card-reader',
          },
          {
            label: 'Best Free POS Software',
            path: 'https://www.fundera.com/blog/free-pos-software',
          },
        ],
      },
      {
        category: 'POS Comparisons',
        links: [
          {
            label: 'Clover vs. Square',
            path: 'https://www.fundera.com/blog/clover-vs-square',
          },
          {
            label: 'Stripe vs. Square',
            path: 'https://www.fundera.com/blog/stripe-vs-square',
          },
          {
            label: 'Stripe vs. PayPal',
            path: 'https://www.fundera.com/blog/stripe-vs-paypal',
          },
          {
            label: 'Square vs. PayPal',
            path: 'https://www.fundera.com/blog/square-vs-paypal',
          },
        ],
      },
      {
        category: 'Learn',
        links: [
          {
            label: 'Merchant Services 101',
            path: 'https://www.fundera.com/blog/merchant-services',
          },
          {
            label: 'How to Accept Credit Card Payments',
            path: 'https://www.fundera.com/blog/accept-credit-card-payments',
          },
          {
            label: 'Credit Card Processing Fees',
            path: 'https://www.fundera.com/blog/credit-card-processing-fees',
          },
          {
            label: 'What Are ACH Deposits?',
            path: 'https://www.fundera.com/blog/ach-deposit',
          },
        ],
      },
    ],
  },
  {
    name: 'HR & Payroll',
    path: 'https://www.fundera.com/blog/hr-for-small-business',
    link: [
      {
        category: 'HR Software',
        links: [
          {
            label: 'Best HR Software',
            path: 'https://www.fundera.com/blog/hr-software-for-small-business',
          },
        ],
      },
      {
        category: 'Payroll Software',
        links: [
          {
            label: 'Best Payroll Software',
            path: 'https://www.fundera.com/blog/payroll-services-for-small-business',
          },
          {
            label: 'Free Payroll Software',
            path: 'https://www.fundera.com/blog/free-payroll-software',
          },
        ],
      },
      {
        category: 'Learn',
        links: [
          {
            label: 'How to Set Up Payroll',
            path: 'https://www.fundera.com/blog/how-to-set-up-payroll',
          },
          {
            label: 'How to Pay Payroll Taxes',
            path: 'https://www.fundera.com/blog/payroll-taxes',
          },
          {
            label: '1099 vs. W2 Employees',
            path: 'https://www.fundera.com/blog/1099-vs-w2-employee',
          },
        ],
      },
    ],
  },
  {
    name: (
      <>
        Legal
        <ExtraMenuWords>Services</ExtraMenuWords>
      </>
    ),
    path: 'https://www.fundera.com/blog/legal-services',
    link: [
      {
        category: 'Entity Types',
        links: [
          {
            label: 'LLC',
            path: 'https://www.fundera.com/blog/do-i-need-an-llc',
          },
          {
            label: 'S-Corporation',
            path: 'https://www.fundera.com/blog/s-corporation',
          },
          {
            label: 'C-Corporation',
            path: 'https://www.fundera.com/blog/c-corporation',
          },
        ],
      },
      {
        category: 'Learn',
        links: [
          {
            label: 'How to Find a Business Attorney',
            path: 'https://www.fundera.com/blog/business-attorney',
          },
          {
            label: 'Where to Get Free Legal Advice',
            path: 'https://www.fundera.com/blog/free-legal-advice',
          },
        ],
      },
    ],
  },
  {
    name: (
      <>
        More
        <ExtraMenuWords>Resources</ExtraMenuWords>
      </>
    ),
    link: [
      {
        category: 'More Categories',
        links: [
          {
            label: 'Business Insurance',
            path: 'https://www.fundera.com/blog/small-business-insurance',
          },
          {
            label: 'Ecommerce Solutions',
            path: 'https://www.fundera.com/blog/ecommerce-platforms',
          },
          {
            label: 'Small Business Taxes',
            path: 'https://www.fundera.com/blog/small-business-taxes',
          },
          {
            label: 'Managing Finances',
            path: 'https://www.fundera.com/blog/business-finance',
          },
          {
            label: 'Building Credit',
            path: 'https://www.fundera.com/blog/free-business-credit-report',
          },
          {
            label: 'Business Operations',
            path: 'https://www.fundera.com/blog/business-operations',
          },
          {
            label: 'Leadership Advice',
            path: 'https://www.fundera.com/blog/leadership-and-advice',
          },
          {
            label: 'Data & Reports',
            path: 'https://www.fundera.com/blog/data-and-reports',
          },
          {
            label: 'Customer Stories',
            path: 'https://www.fundera.com/blog/customer-stories',
          },
        ],
      },
    ],
  },
];

export default pillarPageLinks;
